<template>
  <div
    class="cmp-contacts-contacts-contact_sidewindow-cost_list dbox"
  >
    <NTable
      id="contacts-contacts-contact_sidewindow-cost_list"
      class="h2 c2 p0"
      :headers="costHeaders"
      :items="filteredcosts"
      :config="costTableConfig"
    >
      <template v-slot:thead="{ thcon, thtext }">
        <tr>
          <th
            v-for="(header, index) in costHeaders"
            v-bind="thcon(header.value)"
            :key="header.value"
          >
            <div
              v-if="index !== costHeaders.length - 1"
              class="header-name"
            >
              {{ thtext(header.value) }}
            </div>
            <div v-else>
              <Dropdown
                class="dt-dropdown"
                :options="costStatusTV"
                :selected="
                  costStatusTV.find(
                    (c) => c.value == selectedStatus
                  )
                "
                :placeholder="$t('status')"
                v-on:selectedChange="
                  (e) => onDropdownChange('status', e)
                "
                deselect
                :listHeight="140"
              ></Dropdown>
            </div>
          </th>
        </tr>
      </template>
      <template v-slot:item="{ item, tdcon }">
        <tr
          @click="oncostClicked(item)"
          :title="'Click to see Contact Details'"
        >
          <td v-bind="tdcon('cost')">
            <span class="ut-link ut-text-accent5">
              {{ item["external_ref"] }}
            </span>
          </td>
          <td v-bind="tdcon('date')">
            <span>{{ item["invoice_date"] }}</span>
          </td>
          <td v-bind="tdcon('amount')">
            <span class="txtov text-right">{{ $dft.curr(item["amount"]) }}</span>
          </td>
          <td v-bind="tdcon('status')">
            <div
              class="color-rect"
              :style="{
                'background-color': item['status_color'],
              }"
            ></div>
          </td>
        </tr>
      </template>
    </NTable>
  </div>
</template>

<script>
import Dropdown from "@plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";

import { EventHooks } from "../../../../plugins/text-field";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
    Dropdown,
    NTable,
  },
  props: {
    accountingInfo: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      costTableConfig: createNTableConfig({
        headerStyle: 2,
        fullHeight: true,
      }),
      selectedStatus: null,
    };
  },
  computed: {
    costHeaders: function () {
      return [
        createTableHeader("cost", { fw: 700, f: 1.3 }),
        createTableHeader("date"),
        createTableHeader("amount"),
        createTableHeader("status", { mw: 93 }),
      ];
    },
    costStatusTV: function () {
      return (this.accountingInfo.invoice_status || []).map(
        (is) => {
          return {
            text: this.$t(is[0]),
            value: this.$t(is[1]),
          };
        }
      );
    },
    filteredcosts: function () {
      return (this.accountingInfo.costs || []).filter((e) => {
        if (this.selectedStatus) {
          if (e.status_color == `#${this.selectedStatus}`) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });
    },
  },
  methods: {
    onDropdownChange: function (name, value) {
      switch (name) {
        case "status": {
          this.selectedStatus = value.value;
        }
      }
    },
    oncostClicked: function (cost) {},
    // MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.form-group .dt-dropdown {
  margin: 5px 5px !important;
}
</style>


<style lang="scss">
.cmp-contacts-contacts-contact_sidewindow-cost_list {
  .dt-ntable {
    td:nth-child(4) {
      align-items: center;

      .color-rect {
        width: 10px;
        height: 10px;
        border: 1px solid var(--sprt-5);
        margin-left: calc(50% - 5px);
      }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
      th:nth-child(4),
      td:nth-child(4)
      {
        flex: 0.30 0 50px;
        .dt-dropdown {
          width: 40px;
        }
      }
    }
  }
}
</style>
